import React, { useMemo, useState } from 'react';
import SelectPwcUser from '@components/selectPwcUser/SelectPwcUser';
import { Form } from 'antd';
import useSWR from 'swr';
import { getTeamsNames } from '@service/apis';
import debounce from 'lodash/debounce';

function SelectPwcUserFormItem({
  field,
  fieldName,
  index,
  handleUserSelect,
  guid,
  editInfo,
}) {
  const [searchValue, setSearchValue] = useState();

  // const onChange = useCallback((keywords) => {
  //   setSearchValue(keywords);
  // }, []);
  const { data, error, mutate, isLoading } = useSWR(
    searchValue?.length > 2 ? searchValue : null,
    getTeamsNames,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      // focusThrottleInterval: 1000,
      fallbackData: [],
    },
  );
  const options = useMemo(
    () =>
      data
        .filter((i) => i.guid)
        .map((i) => ({
          fullName: i.name,
          email: i.email,
          country: i.country,
          guid: i.guid,
          staffLevel: i.staff || '',
          location: i.workLoc,
          department: i.jobFunc,
          nonUS: i.nonUS,
          isEUBased: null,
          isLead: index === 0,
          isManager: index === 1,
        })),
    [data],
  );

  return (
    <Form.Item
      key={`email-${index}`}
      {...field}
      // name={`${index}`}
      name={[field.name, fieldName]}
      // label="Team Member"
      fieldKey={[field.fieldKey, fieldName]}
      className="client-column-item member-email"
      // key="email"
      rules={[
        {
          validator(_, value, callback) {
            if (!value || typeof value !== 'string') {
              return Promise.resolve();
            }
            const emailRegex =
              /[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9_\-\.]+\.[a-zA-Z]+/g;
            if (!emailRegex.test(value)) {
              return Promise.reject('Correct email is required');
            }
            if (!options.find((i) => i.email === value) && !guid) {
              return Promise.reject('Not Found');
            }
            return Promise.resolve();
          },
        },
      ]}
      // validateTrigger="onBlur"
    >
      <SelectPwcUser
        index={index}
        onUserChange={handleUserSelect}
        // onChange={onChange}
        isLoading={isLoading}
        options={options}
        setSearchValue={debounce(setSearchValue, 1000)}
        hasGuid={Boolean(guid)}
        curValue={field[fieldName]}
        editInfo={editInfo}
      />
    </Form.Item>
  );
}

export default SelectPwcUserFormItem;
